export default __webpack_public_path__ + "static/media/tv-2020-65hz1000-galleryimages-1-200730.0761a103.jpg";